module.exports = __webpack_public_path__ + "img/image (15).42b05807.png";